import uniqueId from 'lodash/uniqueId';

export const createNewExpertId = (experts) => {
  const existingIds = new Set(experts.map((expert) => String(expert.id)));
  let id = Number(uniqueId());
  while (existingIds.has(String(id))) {
    id += 1;
  }
  return id;
};
